import { useOutletContext } from "react-router-dom";
import { Outline } from "@/pages/OutlineGenerator";

export default function PursuitProposal() {
  const { pursuit } = useOutletContext();
  return (
    <div className="pb-12">
      <Outline
        proposal_id={pursuit?.proposal_id}
        searchType={pursuit?.search_type}
        pursuitId={pursuit?.id}
      />
    </div>
  );
}
